import { Link } from "react-router-dom";
import { MessageCircle, Video } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

export const Footer = ({ whatsapp = "33757829980" }) => {
  return (
    <footer className="relative z-10 border-t border-amber-500/10 mt-24">
      <div className="max-w-7xl mx-auto px-5 py-16 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <BrandMark size={44} />
            <div className="font-serif text-2xl gold-text leading-none">YoungspiritClub</div>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-xs mb-3">
            Le temple moderne de la connaissance de soi. Science, spiritualité et Ingénierie Intérieure.
          </p>
          <span className="text-amber-300/80 font-mono-accent text-sm tracking-wide">YoungspiritClub.com</span>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-amber-400/70 font-mono-accent mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/services" className="hover:text-amber-300">Services</Link></li>
            <li><Link to="/le-cercle" className="hover:text-amber-300">Le Cercle</Link></li>
            <li><Link to="/youtube" className="hover:text-amber-300">YouTube</Link></li>
            <li><Link to="/contact" className="hover:text-amber-300">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-amber-400/70 font-mono-accent mb-4">Prendre contact</h4>
          <a
            href={`https://wa.me/${whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="inline-flex items-center gap-2 text-emerald-300 hover:text-emerald-200 transition-colors"
          >
            <MessageCircle size={18} /> Parler sur WhatsApp
          </a>
          <p className="mt-4 text-slate-400 text-sm inline-flex items-center gap-2">
            <Video size={16} className="text-amber-400/70" /> Conférences via WhatsApp &amp; Zoom
          </p>
        </div>
      </div>
      <div className="border-t border-amber-500/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} YoungspiritClub — YoungspiritClub.com — Tous droits réservés.
      </div>
    </footer>
  );
};
